import { useQueries, useQuery } from '@tanstack/react-query';
import { IBulkOperationResult, UserSessionContext } from '../../extViewmodels';
import { DownloadTranscriptsRequest } from '../../extViewmodels/sdk/models/requests/Zoom';
import { ZoomTranscriptView } from '../../extViewmodels/sdk/models/Zoom';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { LevStandardQueryMeta } from '../../web/ReactQueryProvider';

const BASE_QUERY_KEY = 'lead/demos/transcripts';

type Params = {
	body: DownloadTranscriptsRequest;
	meta?: LevStandardQueryMeta;
	staleTime?: number;
};

const getQueryConfig = (userSession: UserSessionContext, params: Params) => {
	const { body, ...queryParams } = params;
	return {
		queryKey: [BASE_QUERY_KEY, body],
		queryFn: async () => {
			return new Promise<ZoomTranscriptView[]>((resolve, reject) => {
				userSession.webServiceHelper.callWebServiceWithBulkOperationResult<ZoomTranscriptView>(
					`lead/demos/transcripts`,
					'POST',
					body,
					data => {
						resolve(data.succeeded);
					},
					error => {
						if (error.systemCode === 400) {
							const data = error as IBulkOperationResult<ZoomTranscriptView>;
							if (data.succeeded?.length) {
								resolve(data.succeeded);
							}
						}
						reject(error);
					}
				);
			});
		},
		...queryParams,
	};
};

export function useDemoTranscriptsQuery(params: Params) {
	const userSession = useUserSession();
	return useQuery(getQueryConfig(userSession, params));
}

export function useDemoTranscriptQueries(params: Params[]) {
	const userSession = useUserSession();
	return useQueries({
		queries: params.map(param => getQueryConfig(userSession, param)),
	});
}
